/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { httpService } from 'src/core/services/api/httpService';
import { luisRequestOptionsBuilder } from 'src/core/utils/api/luisRequestOptionsBuilder';
import { urlBuilder } from 'src/core/utils/api/urlBuilder';
import { createService } from 'src/core/utils/createService';
import { AzureOpenAiDeploymentSwagger } from 'src/customText/core/services/gpt/customTextGptSwagger';

export const getAzureOpenAiService = createService(() => {
    /**
     * @docLink https://learn.microsoft.com/en-us/rest/api/cognitiveservices/azureopenaistable/deployments/list?tabs=HTTP
     */
    const getAzureOpenAiDeployments = async ({ endpoint, serviceKey }: { endpoint: string; serviceKey: string }) => {
        const urlOptions = luisRequestOptionsBuilder()
            .useCustomHeader('api-key', serviceKey)
            .build();
        const url = urlBuilder()
            .baseUrl(endpoint)
            .resource('openai', 'deployments')
            .queryParam('api-version', '2022-12-01')
            .build();

        const { data: deployments } = await httpService.get<{ data: AzureOpenAiDeploymentSwagger[] }>(url, urlOptions);

        return deployments.data;
    };

    return { getAzureOpenAiDeployments };
});
